module.exports = __webpack_public_path__ + "static/img/sarl-fast-informatique.2d788ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pub/sarl-fast-informatique.jpg
// module id = ed0w
// module chunks = 2 4